import "./ScoreCardInitialScreen.css";
import cardImage from "../../../assets/images/score-card/score-card-image.svg";
import headerImage from "../../../assets/images/score-card/score-initial-header.png";
import starIcon from "../../../assets/images/score-card/score-initial-text-icon.svg";
import rightArrowIcon from "../../../assets/images/score-card/score-initial-right-arrow.svg";
import { useNavigate } from "react-router-dom";
import ROUTE_PATHS from "utils/routePaths";

const ScoreCardInitialScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="wms-mobile-container">
      <div className="score-card-initial-screen-container">
        <img
          src={headerImage}
          alt="header-image-icon"
          className="header-image"
        />
        <img src={cardImage} alt="card-image-icon" className="card-image" />
        <div className="text-container">
          <img src={starIcon} alt="star-icon" />
        </div>
        <div
          className="score-card-initial-screen-button-container"
          onClick={() => navigate(ROUTE_PATHS.WSM_SCORE_CARD_MATTERS_SCREEN)}
        >
          <>
            LET’S FIND UR BOTTLENECK
            <img
              src={rightArrowIcon}
              className="score-card-initial-screen-arrow-icon"
              alt="right-arrow-icon"
            />
          </>
        </div>
      </div>
    </div>
  );
};

export default ScoreCardInitialScreen;
